import React, { useContext } from "react";
import Category from "../category/category.js";
import { usePages } from "../../scripts/usePages.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import "./style.css";
import { useUpdateEffect } from "../../../../../../../merchant/panel/hooks/useUpdateEffect.js";
import { groupContext } from "../index.js";
export default function Gallery(props) {
    var _a, _b, _c;
    const group = useContext(groupContext);
    const displayPages = ((_a = group === null || group === void 0 ? void 0 : group.appearance) === null || _a === void 0 ? void 0 : _a.displayMethod) === "sharded";
    const { currentPage, setCurrentPage, displayableCategories, pages } = usePages((_c = (_b = group === null || group === void 0 ? void 0 : group.appearance) === null || _b === void 0 ? void 0 : _b.shardSize) !== null && _c !== void 0 ? _c : 500, props.categories);
    useUpdateEffect(() => {
        window.scrollTo({
            top: 0,
        });
    }, [currentPage]);
    return (React.createElement("div", { className: "gallery-container" },
        displayPages === true && (React.createElement("div", { className: "page-chooser-container" },
            React.createElement("h1", null, "Strony"),
            React.createElement("div", { className: "pages-list" }, new Array(pages).fill(undefined).map((_, i) => (React.createElement(Button, { version: "alternative", key: i, classNames: `page-button ${currentPage === i ? "page-button-active" : ""}`, onClick: () => setCurrentPage(i) }, i + 1)))))),
        displayPages === true ?
            displayableCategories.map((category, index) => {
                return (React.createElement(Category, { key: category === null || category === void 0 ? void 0 : category.index, category: category, categoryIndex: category === null || category === void 0 ? void 0 : category.index, galleryType: props.type }));
            })
            : props.categories.map((category, index) => {
                return (React.createElement(Category, { key: index, category: category, categoryIndex: index, galleryType: props.type }));
            }),
        displayPages === true && (React.createElement("div", { className: "page-chooser-container" },
            React.createElement("h1", null, "Strony"),
            React.createElement("div", { className: "pages-list" }, new Array(pages).fill(undefined).map((_, i) => (React.createElement(Button, { version: "alternative", key: i, classNames: `page-button ${currentPage === i ? "page-button-active" : ""}`, onClick: () => setCurrentPage(i) }, i + 1))))))));
}
